import { Account } from 'next-auth';

export enum TenantType {
  PERSONAL = 'Personal',
  BUSINESS = 'BusinessTransactionalSMB',
}

export interface CRRDomainsResponse {
  content: string[];
  totalElements: number;
}

export interface CRRNodeResponse {
  type: TenantType;
  nodeId: string;
  accountName?: string;
}

export interface AccountNodeResponse {
  resourceId: string;
}

export type ReasonCodes = ExchangeReason;
enum ExchangeReason {
  NOT_ALLOWED = 'NOT_ALLOWED',
}

export interface Reason {
  code: ReasonCodes;
  description: string;
}

export interface ExchangeContext {
  cartId?: string;
  isExchanged: boolean;
  reason: Reason[];
}

export interface WellKnownConfig {
  access_policies_endpoint: string;
  authorization_endpoint: string;
  device_authorization_endpoint: string;
  end_session_endpoint: string;
  grant_types_supported: string[];
  id_token_signing_alg_values_supported: string[];
  introspection_endpoint: string;
  issuer: string;
  jwks_uri: string;
  lookup_endpoint: string;
  logout_endpoint: string;
  policy_endpoint: string;
  response_types_supported: string[];
  revocation_endpoint: string;
  subject_types_supported: string[];
  token_endpoint: string;
  token_endpoint_auth_methods_supported: string[];
  userinfo_endpoint?: string;
}

export interface OAuthContext {
  provider: {
    callbackUrl: string;
  };
  params: {
    code?: string;
    state?: string;
  };
}

declare module 'next-auth' {
  /**
   * Returned by `useSession`, `getSession` and received as a prop on the `SessionProvider` React Context
   */
  interface Session {
    access_token?: string;
    id_token?: string;
    expires?: string;
    tenantId?: string;
    stratusUserId?: string;
  }
}

declare module 'next-auth/adapters' {
  interface AdapterSession {
    id: string;
  }
  interface Adapter {
    getAccountByEmail(email: string): Promise<Account | null>;
    cleanupExistingUserData(
      providerAccountId: string,
      provider: string
    ): Promise<void>;
  }
}
